import React, { useState } from 'react';
import { Play, Pause } from 'lucide-react';

const AudioPlayer = ({ file, audioRef, onPlayAction }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
      if (onPlayAction) onPlayAction(); 
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleTimeUpdate = () => {
    const current = audioRef.current.currentTime;
    const total = audioRef.current.duration;
    setProgress((current / total) * 100 || 0);
  };

  const handleSeek = (e) => {
    const seekTime = (e.target.value / 100) * audioRef.current.duration;
    audioRef.current.currentTime = seekTime;
    setProgress(e.target.value);
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "00:00";
    const mins = Math.floor(time / 60);
    const secs = Math.floor(time % 60);
    return `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div className="max-w-xl mx-auto mb-10 bg-slate-950/80 p-6 rounded-3xl border border-slate-800 shadow-inner">
      <audio 
        ref={audioRef} 
        src={file} 
        onTimeUpdate={handleTimeUpdate} 
        onLoadedMetadata={() => setDuration(audioRef.current.duration)}
        onEnded={() => setIsPlaying(false)}
        className="hidden" 
      />

      <div className="flex items-center gap-6">
        <button 
          onClick={togglePlay}
          className="w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center text-black hover:scale-110 active:scale-95 transition-all shadow-lg shadow-amber-500/20"
        >
          {isPlaying ? <Pause size={24} fill="black" /> : <Play size={24} fill="black" />}
        </button>

        <div className="flex-1 space-y-2">
          <div className="flex justify-between text-[10px] font-black text-slate-500 uppercase tracking-widest">
            <span>{formatTime(audioRef.current?.currentTime)}</span>
            <span>{formatTime(duration)}</span>
          </div>
          <input 
            type="range" 
            value={progress} 
            onChange={handleSeek}
            className="w-full h-1.5 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-amber-500"
          />
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;